import React from "react";
import ReactDOM from "react-dom/client";
import ProspectPage from "./ProspectPage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import BasePage from "./BasePage";
import CompanyPage from "./CompanyPage";
import StatisticsPage from "./StatisticsPage";
import ProfilesPage from "./ProfilesPage";
import LoginProblemPage from "./LoginProblemPage";
import { installLoginHandler, LOGIN_PROBLEM_PATH } from "./login";

installLoginHandler();

const router = createBrowserRouter([
  {
    path: LOGIN_PROBLEM_PATH,
    element: <LoginProblemPage />,
  },
  {
    path: "/",
    element: <BasePage />,
    children: [
      {
        path: "/",
        element: <ProspectPage />,
      },
      {
        path: "/companies",
        element: <CompanyPage />,
      },
      {
        path: "/statistics",
        element: <StatisticsPage />,
      },
      {
        path: "/profiles",
        element: <ProfilesPage />,
      },
    ],
  },
]);
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
